import { ReactComponent as CrossIcon } from "assets/cross.svg";
import React, { ReactNode } from "react";
import { ReactComponent as ArrowIcon } from "render/ui/icons/arrow.svg";
import { LogoHeader } from "render/ui/layout/LogoHeader";
import { Typography } from "render/ui/presentation/Typography";
import { IconButton } from "render/ui/trigger/IconButton";
import styles from "./styles.module.sass";

interface EditPageProps {
  onBack: () => void;
  title: ReactNode;
  subTitle?: ReactNode;
  cta: ReactNode;
}

export function EditPage({
  children,
  onBack,
  title,
  subTitle,
  cta,
}: React.PropsWithChildren<EditPageProps>) {
  return (
    <div className={styles.EditPage}>
      <div className={styles.content}>
        <div className={styles.header}>
          <LogoHeader
            leftElement={
              <div className={styles.closeIcon}>
                <div className={styles.mobile}>
                  <IconButton icon={<ArrowIcon />} onClick={onBack} />
                </div>
                <div className={styles.desktop}>
                  <IconButton icon={<CrossIcon />} onClick={onBack} />
                </div>
              </div>
            }
          />
        </div>
        <div className={styles.container}>
          <div className={styles.titleContainer}>
            <div className={styles.title}>
              <Typography variant="display-s">{title}</Typography>
            </div>
            {subTitle && (
              <Typography variant="body-m" color="subtle">
                {subTitle}
              </Typography>
            )}
          </div>
          {children}
        </div>
        <div className={styles.cta}>{cta}</div>
      </div>
    </div>
  );
}
